import ApiService from '@/common/api/api.service';

let apiBasePath = 'FechamentoCursoTurma';
const FechamentoCursoTurmaService = {
  // FUNÇÕES CRUD:

  async listar(filtro, paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${apiBasePath}`, {
      params: {
        turmaId: filtro.turmaId,
        cursoId: filtro.cursoId,
        segmentacaoId: filtro.segmentacaoId,
        anoLetivoId: filtro.anoLetivoId,
        ...paginacao, 
        CampoOrdenado: campoOrdenado, 
        OrdenacaoAscendente: ordem 
      },
    });
    return data;
  },
  async fechar(form, filtros) {
    const payload = {
      anoLetivoId: filtros.anoLetivoId,
      cursoId: filtros.cursoId,
      turmaId: form.turmaId,
      segmentacaoId: filtros.segmentacaoId,
      fechamentoCursoTurmaId: form.id
    };

    let { data } = await ApiService.put(`${apiBasePath}/fechar`, payload);
    
    return data;
  },
  async reabrir(form, item) {
    let { data } = await ApiService.put(`${apiBasePath}/reabrir`, {
      cursoId: form.cursoId,
      segmentacaoId: form.segmentacaoId,
      anoLetivoId: form.anoLetivoId,
      FechamentoCursoTurmaId: item,
    });
    return data;
  },
  async validar(form, item) {
    let { data } = await ApiService.get(`${apiBasePath}/validar`, {
      params: {
        turmaId: item.turmaId,
        cursoId: form.cursoId,
        segmentacaoId: form.segmentacaoId,
        anoLetivoId: form.anoLetivoId,
        FechamentoCursoTurmaId: form.FechamentoCursoTurmaId,
      },
    });
    return data;
  },
  async liberarBoletim({ id }) {
    let { data } = await ApiService.put(`${apiBasePath}/liberar-portal/${id}`);
    return data;
  },
  async liberarRecuperacaoSegmentacao({ id }) {
    let { data } = await ApiService.put(
      `${apiBasePath}/liberar-recuperacao-portal/${id}`
    );
    return data;
  },
  async bloquearRecuperacaoSegmentacao({ id }) {
    let { data } = await ApiService.put(
      `${apiBasePath}/bloquear-recuperacao-portal/${id}`
    );
    return data;
  },
  async imprimirParecerDescritivo(form) {
    let { data } = await ApiService.get(`${apiBasePath}/imprimir-parecer-descritivo`, {
      params: {
        TurmaId: form.turmaId,
        SegmentacaoId: form.segmentacaoId,
        CursoId:form.cursoId
      },
    });
    return data;
  },
};

export default FechamentoCursoTurmaService;
